import SelfAccountCreate from '@containers/account/SelfAccountCreate';

const SelfAccountCreatePage = () => {
  return <SelfAccountCreate />;
};

export default SelfAccountCreatePage;
